"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLoadResourcesPlugin = void 0;
const makeLoadResourcesPlugin = (o) => {
    return {
        type: 'backend',
        init() { },
        async read(language, ns) {
            let phraseResources = {};
            try {
                phraseResources = await o.fetchPhraseResources(language, ns);
            }
            catch (error) {
                // Note: thrown errors here seem to be swallowed by i18next
                o.onFetchResourceError(error);
            }
            // When we fetch the default namespace, we'll also fetch the moment resources
            if (ns === o.defaultNamespace) {
                let momentLocale = null;
                let momentFormats = null;
                try {
                    const momentResources = await o.fetchMomentResources(language);
                    momentLocale = momentResources.momentLocale;
                    momentFormats = momentResources.momentFormats;
                }
                catch (error) {
                    // Note: thrown errors here seem to be swallowed by i18next
                    o.onFetchResourceError(error);
                }
                // Note: There is no moment locale for 'en'. It's included in moment already.
                if (momentLocale) {
                    o.momentLibrary.defineLocale(language, momentLocale);
                    // moment.defineLocale also changes the global moment instance to the newly defined locale...
                    // So, let's put it back to 'en' (The default) to avoid any confusion
                    o.momentLibrary.locale('en');
                }
                if (momentFormats) {
                    o.momentFormatsByLanguage.set(language, momentFormats);
                }
            }
            return phraseResources;
        },
    };
};
exports.makeLoadResourcesPlugin = makeLoadResourcesPlugin;
//# sourceMappingURL=makeLoadResourcesPlugin.js.map